<template>
  <div>
    <div v-if="!confirmed || !user || state === 'migrationExtras'">
      <authentication />
    </div>
    <div v-else>
      <preferences />
    </div>
  </div>
</template>

<script>
import { AmplifyEventBus } from "aws-amplify-vue";
import { mapState } from "vuex";
import Authentication from "@/components/Authentication.vue";
import Preferences from "@/components/Preferences.vue";
export default {
  name: "Account",
  components: {
    Authentication,
    Preferences
  },
  data() {
    return {};
  },
  computed: {
    ...mapState("user", ["user", "state", "confirmed"])
  },
  async created() {},
  methods: {
    signIn() {
      let config = this.$Amplify.Auth._config;
      let url =
        config.oauth.domain +
        "/login?redirect_uri=" +
        config.oauth.redirectSignIn +
        "&response_type=" +
        config.oauth.responseType +
        "&client_id=" +
        config.userPoolWebClientId;
      window.location.replace(url);
    },
    async accountAuth() {
      let { data } = await this.$axios.get(`/accountAuth`, {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      });
      this.authToken = data;
    },
    signOut() {
      this.user = "";
      localStorage.clear();
      //window.location.replace('/')
    },
    async checkUser() {
      this.user = await this.$Amplify.Auth.currentAuthenticatedUser();
    },
    formatName(name) {
      let [last, first] = name.split(",");
      return `${first} ${last}`;
    },
    formatAccountName(name) {
      return;
    },
    async getAccount(userId = 444455555) {
      this.accountLoading = true;
      let { data: account } = await this.$axios.get(
        `/accounts?userHandle=${userId}`,
        {
          headers: {
            Authorization: `Bearer ${this.authToken}`
          }
        }
      );
      this.account = account;
      this.accountLoading = false;
    },
    async getCallToAction(userId = 444455555) {
      this.actionLoading = true;
      let { data: actions } = await this.$axios.get(
        `/callToAction?userHandle=${userId}`,
        {
          headers: {
            Authorization: `Bearer ${this.authToken}`
          }
        }
      );
      this.actions = actions;
      this.actionLoading = false;
    },
    async getActionTags(userId = 444455555, accountId = "00001555555") {
      this.actionTagsLoading = true;
      let { data: actionTags } = await this.$axios.get(
        `/accounts/${accountId}/actionTags?userHandle=${userId}`,
        {
          headers: {
            Authorization: `Bearer ${this.authToken}`
          }
        }
      );
      this.actionTags = actionTags;
      this.actionTagsLoading = false;
    },
    async getFullAccount() {
      this.fullAccountLoading = true;
      let { data: full } = await this.$axios.get(
        `https://api.alerus.com/accounts/00001555555?userHandle=444455555&participantId="partipandID"&planNumber=000015`,
        {
          headers: {
            Authorization: `Bearer ${this.authToken}`
          }
        }
      );
      this.fullAccount = full;
      this.fullAccountLoading = false;
    },
    async branchLookup(branchZip) {
      let { data: branch } = await this.$axios.get(
        `/branchCodeLookup?zipCode=${branchZip}`
      );
      this.branchInfo = branch;
    },
    async getSystem(system = this.system) {
      this.newUrl = true;
      let { data: authSystem } = await this.$axios.get(
        `/getSystemLink?system=${system}`,
        {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        }
      );
      this.authUrl = `https://applanding.alerus.com/?auth=${authSystem}`;
      this.newUrl = false;
    }
  }
};
</script>

<style lang="scss">
</style>
